import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { TRANSLATE_BUTTON } from '../constants/TranslationConstants';

interface TranslateButtonProps {
  onTranslate: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const TranslateButton = ({ onTranslate, disabled = false, isLoading = false }: TranslateButtonProps) => {
  return (
    <Button
      variant="contained"
      onClick={onTranslate}
      disabled={disabled || isLoading}
      size="small"
      sx={{
        fontSize: "10px",
        background: (disabled || isLoading) ? "#9e9e9e" : "#006684",
        height: "30px",
        color: "#FFFFFF",
        cursor: (disabled || isLoading) ? "not-allowed" : "pointer",
        textTransform: "capitalize",
        fontWeight: "600",
        minWidth: "120px",
        '&:hover': {
          backgroundColor: (disabled || isLoading) ? "#9e9e9e" : "#005a70",
        }
      }}
      startIcon={isLoading ? <CircularProgress size={14} color="inherit" /> : null}
    >
      {isLoading ? 'Translating...' : TRANSLATE_BUTTON}
    </Button>
  );
};

export default TranslateButton;